module.exports = __webpack_public_path__ + "static/media/SarahSwitek_07_EnergyLevel_4.575ea922.mp3";